<!-- 商品列表 -->
<template>
  <div id="kt_post" class="post flex-column-fluid">
    <VipPayComponent ref="VipPayComponent" @checkPay="checkPay"></VipPayComponent>
    <TitleCard title="商学院管理" class="mt-5 mb-5" style="margin: 0 auto; max-width: 97%; border-radius: 15px">
      <template v-slot:subTitle class="position-relative">
        <ul class="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
          <li class="breadcrumb-item text-muted" rel="stylesheet"
              href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap"
              style="font-family: 'Roboto', sans-serif">
            Business School Management
          </li>
        </ul>
      </template>
    </TitleCard>
    <div id="kt_content_container" class="container"
         style="max-width: 98%; flex-direction: row !important; display: flex">
      <div id="kt_app_main" class="app-main flex-column flex-row-fluid">
        <div class="d-flex flex-column flex-column-fluid">
          <div id="kt_app_content" class="app-content" style="padding-top: 0px">
            <div class="card card-flush">
              <div class="card-body" style="padding: 17px 17px">
                <ul class="nav nav-tabs nav-line-tabs nav-line-tabs-2x border-transparent fs-4 fw-semibold mb-15"
                    style="margin-bottom: 0 !important; position: relative">
                  <li v-for="(item, i) in orderStatus" :key="i" class="nav-item" v-if="role.includes('secondTierSuppliers') && i === 0 ||
										(role.includes('firstGradeSupplier') && (i === 0 || i === 1))">
                    <a :class="index === i + 1 ? 'active' : ''" :href="`#kt_tab_pane_${i + 1}`"
                       class="nav-link text-active-primary d-flex align-items-center pb-5"
                       data-bs-toggle="tab" @click="index = i + 1"
                       style="font-size: 13px; font-weight: bold">
                      <i :class="item.icon"></i>{{ item.title }}</a>
                  </li>
                  <div class="d-flex align-items-center py-3">
                    <!--begin::Button-->

                    <div v-if="index === 1" style="position: absolute; right: 0; padding: 0px 30px">
                      <a href="javascript:void(0)" class="btn btn-sm btn-primary mx-2"
                         @click="$router.push({ path: 'articleManage/addOrUpdateArticle' })">创建</a>
<!--                      <a class="btn btn-sm btn-primary mx-2" href="javascript:void(0)"
                         @click="$router.push({ path: 'travel/travel_group' })">分组管理</a>-->
<!--                      <a href="javascript:void(0)" class="btn btn-sm btn-primary mx-2"
                         @click="exportTool">导出工具</a>-->
<!--                      <a href="javascript:void(0)" class="mx-2">
                        <el-dropdown size="small" split-button type="primary"
                                     @command="batchOperations">
                          批量操作
                          <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="push">挑选并推送线路
                            </el-dropdown-item>
                          </el-dropdown-menu>
                        </el-dropdown>
                      </a>-->
                    </div>
                  </div>
                </ul>
                <!--    自有商品     -->
                <OwnGoods v-if="index === 1" @editEvent="gotoGoods" @setArrId="setArrId" ref="OwnGoods">
                </OwnGoods>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 推送规则 -->
    <ModalDialog title="挑选上架" id="pushGoodsAll" ref="pushGoodsAll" width="850px">
      <div>
        <el-form ref="form" :model="pushGoodsObj" label-width="80px">
          <el-form-item label="推送目标" :required="true">
            <el-checkbox-group v-model="pushGoodsObj.selectionObjects" @change="changeSelectionObjects">
<!--              <el-checkbox label="group" :disabled="pushGoodsObj.selectionObjects.includes('topic')
								|| pushGoodsObj.selectionObjects.includes('shop') || pushGoodsObj.salePriceChange == 1">分组
              </el-checkbox>-->
              <el-checkbox label="shop"
                           :disabled="pushGoodsObj.selectionObjects.includes('group')">精选目的地
              </el-checkbox>
<!--              <el-checkbox label="topic"-->
<!--                           :disabled="pushGoodsObj.selectionObjects.includes('group')">活动-->
<!--              </el-checkbox>-->
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="已选商品">
            <span style="color: red">{{ state ? "1" : idArr.length }} </span> 件商品
          </el-form-item>
        </el-form>
      </div>
      <el-button type="primary" style="float: right; margin-right: 20px" @click="nextPush">下一步<i
          class="el-icon-arrow-right el-icon--right"></i></el-button>
    </ModalDialog>

    <!-- 推送目标 -->
    <ModalDialog title="选择具体推送目标" id="pushGrounp" ref="pushGrounp"
                 :width="pushGoodsObj.selectionObjects.length * 400 + 'px'">
      <div style="display: flex">
        <div style="width: 400px; flex: 1; height: 400px; overflow-y: scroll"
             v-if="pushGoodsObj.selectionObjects.includes('shop')">
          <h3>精选目的地</h3>
          <div>
            <el-tree :data="shopProps" show-checkbox node-key="id" ref="shopTree" @check="shopTreeNodeClick">
            </el-tree>
          </div>
        </div>
<!--        <div style="width: 400px; flex: 1; height: 400px; overflow-y: scroll"-->
<!--             v-if="pushGoodsObj.selectionObjects.includes('topic')">-->
<!--          <h3>活动</h3>-->
<!--          <div>-->
<!--            <el-tree :data="topicProps" ref="topicTree" node-key="id" show-checkbox @check="topicTreeNodeClick">-->
<!--            </el-tree>-->
<!--          </div>-->
<!--        </div>-->
      </div>
      <el-divider></el-divider>

      <el-button type="primary" style="float: right; margin-right: 20px" @click="submitPush">提交&nbsp;&nbsp;<i
          class="el-icon-arrow-right el-icon--right"></i></el-button>
      <el-button type="primary" style="float: right; margin-right: 20px" @click="$refs.pushGrounp.close()">上一步<i
          class="el-icon-arrow-left el-icon--left"></i></el-button>
    </ModalDialog>

    <!-- 导出工具 -->
    <ModalDialog id="exportTool" ref="exportTool" title="导出工具" style="padding-bottom: 0px !important;">
      <el-row>

        <el-col v-loading="excelLoading" :span="8" class="mg-r-20 " align="center" justify="center">
          <label class="fs-6 form-label fw-bold">线路导出</label>
          <el-tooltip class="item" content="根据线路列表页的筛选条件导出对应的线路数据" effect="dark"
                      placement="top-start">
            <i class='el-icon-info'/>
          </el-tooltip>
          <br>
          <img class="cursor-pointer bg-hover-secondary" src="/images/XLS.png" alt="点击导出数据"
               @click="exportData(1,1)"/>
        </el-col>
      </el-row>
      <div class="row fv-row mb-7 fv-plugins-icon-container"></div>
      <div style="margin-left: 330px !important;">
        <button type="button" class="btn btn-primary" @click="exportData(0,2)">
          关闭
        </button>
      </div>
    </ModalDialog>

    <el-dialog :visible.sync="templatePicUrlVisible" width="60%">
      <el-image style="width: 100%; height: 50%" :src="templatePicUrl"></el-image>
    </el-dialog>

    <!--挑选导出ppt的商品数据-->
    <ModalDialog title="请挑选商品到礼包" ref="goodsListDialog" width="95%">
      <el-row :gutter="20">
        <el-col :span="18">
          <div>
            <div style="width: 100%">
              <div class="card">
                <div class="card-body" style="padding: 5px 5px !important;">
                  <div class="d-flex align-items-center">
                    <div class="position-relative w-md-400px me-md-2">
                      <span
                          class="svg-icon svg-icon-3 svg-icon-gray-500 position-absolute top-50 translate-middle ms-6">
                        <svg height="24px" version="1.1" viewBox="0 0 24 24" width="24px"
                             xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                          <g fill="none" fill-rule="evenodd" stroke="none" stroke-width="1">
                            <rect height="24" width="24" x="0" y="0"></rect>
                            <path
                                d="M14.2928932,16.7071068 C13.9023689,16.3165825 13.9023689,15.6834175 14.2928932,15.2928932 C14.6834175,14.9023689 15.3165825,14.9023689 15.7071068,15.2928932 L19.7071068,19.2928932 C20.0976311,19.6834175 20.0976311,20.3165825 19.7071068,20.7071068 C19.3165825,21.0976311 18.6834175,21.0976311 18.2928932,20.7071068 L14.2928932,16.7071068 Z"
                                fill="#000000" fill-rule="nonzero" opacity="0.3"></path>
                            <path
                                d="M11,16 C13.7614237,16 16,13.7614237 16,11 C16,8.23857625 13.7614237,6 11,6 C8.23857625,6 6,8.23857625 6,11 C6,13.7614237 8.23857625,16 11,16 Z M11,18 C7.13400675,18 4,14.8659932 4,11 C4,7.13400675 7.13400675,4 11,4 C14.8659932,4 18,7.13400675 18,11 C18,14.8659932 14.8659932,18 11,18 Z"
                                fill="#000000" fill-rule="nonzero"></path>
                          </g>
                        </svg>
                      </span>
                      <input id="sTitle" v-model="paramss.title" class="form-control form-control-solid ps-10"
                             name="shopName" placeholder="商品名称" type="text" value=""/>
                    </div>
                    <div class="d-flex align-items-center">
                      <div class="btn btn-primary me-5 btn-sm" @click="shaixuan">
                        查询
                      </div>
                      <div class="btn btn-secondary me-5 btn-sm" @click="resetBtn">
                        重置
                      </div>
                      <a id="kt_horizontal_search_advanced_link" class="btn btn-link" data-bs-toggle="collapse"
                         href="#kt_advanced_search_form">高级查询</a>
                    </div>
                  </div>
                  <!--begin::高级搜索-->
                  <div id="kt_advanced_search_form" class="collapse">
                    <div class="separator separator-dashed mt-9 mb-6"></div>
                    <div class="row g-8 mb-8">
                      <div class="col-lg-3">
                        <label class="fs-6 form-label">一级分类</label>
                        <br/>
                        <el-select v-model="paramss.categoryId1" placeholder="请选择" @change="getCategory(1)">
                          <el-option v-for="item in categoryId1" :key="item.categoryId" :label="item.fullName"
                                     :value="item.categoryId">
                          </el-option>
                        </el-select>
                      </div>
                      <div class="col-lg-3">
                        <label class="fs-6 form-label">二级分类</label>
                        <br/>
                        <el-select v-model="paramss.categoryId2" placeholder="请选择" @change="getCategory(2)">
                          <el-option v-for="item in categoryId2" :key="item.categoryId" :label="item.fullName"
                                     :value="item.categoryId">
                          </el-option>
                        </el-select>
                      </div>

                      <div class="col-lg-3" v-if="paramss.type == 1">
                        <label class="fs-6 form-label fw-bolder text-dark"
                        >库存区间</label
                        >
                        <div class="row">
                          <div class="col-lg-6 fv-row fv-plugins-icon-container">
                            <input
                                type="text" id="minPoolSupplPrice" name="minPoolSupplPrice"
                                class="form-control form-control-lg form-control-solid mb-3 mb-lg-0"
                                v-model="paramss.minStock" placeholder="最小值" value=""
                                oninput="value=value.replace(/[^\d^\.]+/g,'').replace('.','$#$').replace(/\./g,'').replace('$#$','.')"
                            />
                            <div
                                class="fv-plugins-message-container invalid-feedback"
                            ></div>
                          </div>
                          <div class="col-lg-6 fv-row fv-plugins-icon-container">
                            <input
                                type="text"
                                id="maxPoolSupplPrice"
                                name="maxPoolSupplPrice"
                                class="form-control form-control-lg form-control-solid"
                                v-model="paramss.maxStock"
                                oninput="value=value.replace(/[^\d^\.]+/g,'').replace('.','$#$').replace(/\./g,'').replace('$#$','.')"
                                placeholder="最大值"
                                value=""
                            />
                            <div
                                class="fv-plugins-message-container invalid-feedback"
                            ></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="table-responsive" v-loading="loading" element-loading-text="拼命加载中"
               element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
            <table class="table align-middle table-row-dashed table-hover fs-6 gy-5 dataTable no-footer">
              <thead>
              <tr class="text-start text-gray-500 fw-bold fs-7 text-uppercase gs-0">
                <th class="min-w-300px" tabindex="0" aria-controls="kt_ecommerce_products_table" rowspan="1" colspan="1"
                    aria-label="Product: activate to sort column ascending" style="width: 212.141px">
                  商品信息
                </th>
                <th>
                  分类
                </th>
                <th class="text-center">
                  市场价
                </th>
                <th class="text-center" v-if="paramss.type==1">
                  销售价
                </th>
                <th class="text-center">
                  运费模板
                </th>
                <th class="text-center">
                  库存
                </th>
                <th class="text-center">
                  商品来源
                </th>
                <th aria-label="操作" class="text-center sorting_disabled" colspan="1" rowspan="1"
                    style="width: 100px;">
                  操作
                </th>
              </tr>
              </thead>
              <tbody class="fw-semibold text-gray-600">
              <tr v-for="(item, index) in selGoodsList" :class="{ old: index % 2 == 0, even: index % 2 != 0 }"
                  :key="index">
                <td>
                  <div class="d-flex align-items-center">
                    <a href="javascript:void(0);" class="symbol symbol-50px">
                      <img class="symbol-label lozad" v-if="item.picUrl.indexOf('http') == 0" :src="`${item.picUrl}`"/>
                      <img class="symbol-label lozad" v-else :src="`https://www.3jzc.cn${item.picUrl}`"/>
                    </a>
                    <div class="ms-5">
                      <a href="javascript:void(0);" class="text-gray-800 text-hover-primary fs-5"
                         data-kt-ecommerce-product-filter="product_name">{{ item.title }}</a>
                    </div>
                  </div>
                </td>
                <td>
                  <div v-html="item.categoryName"></div>
                </td>
                <td class="text-center">{{ item.price | format }}</td>
                <td class="text-center" v-if="paramss.type==1">{{ item.salePrice | format }}</td>
                <td class="text-center" v-if="paramss.type==1">{{ item.freightId }}</td>
                <td class="text-center" v-else-if="paramss.type==2 && item.isJD == 2">厂供模板</td>
                <td class="text-center" v-else-if="paramss.type==2 && item.isJD == 1">京东模板</td>
                <td class="text-center" v-if="paramss.type==1">{{ item.stock || 0 }}</td>
                <td class="text-center" v-else-if="paramss.type==2 && item.isJD == 2">{{ item.stock || 0 }}</td>
                <td class="text-center" v-else-if="paramss.type==2 && item.isJD == 1">99</td>
                <td class="text-center" v-if="paramss.type==1">{{ item.type }}</td>
                <td class="text-center" v-else-if="paramss.type==2 && item.isJD == 1">京东</td>
                <td class="text-center" v-else-if="paramss.type==2 && item.isJD == 2">自有</td>
                <!-- 操作 -->
                <td class="text-center">
                  <el-link type="success" @click="addGroupGoods(item)" v-if="!idsArr.includes(item.id)">添加</el-link>
                </td>
              </tr>
              </tbody>
            </table>
            <Pagination :total-items="totalCount" @page-change="pageChange" ref="Pagination"></Pagination>
          </div>
        </el-col>
        <el-col :span="6">
          <div style="display: flex;justify-content:space-between;">
            <h4>已选商品<span style="font-size:12px;margin-left: 5px;">(共选择 {{ pptGoodsList.length }} 个商品)</span>
            </h4>
            <el-button v-if="pptGoodsList.length!=0" size="small" type="danger" @click="clearSelectedGoods">
              清空已选商品
            </el-button>
          </div>
          <div class="table-responsive">
            <table class="table align-middle table-row-dashed table-hover fs-6 gy-5 dataTable no-footer">
              <thead>
              <tr class="text-start text-gray-500 fw-bold fs-7 text-uppercase gs-0">
                <th class="min-w-200px" tabindex="0" aria-controls="kt_ecommerce_products_table" rowspan="1" colspan="1"
                    aria-label="Product: activate to sort column ascending" style="width: 212.141px">
                  商品信息
                </th>
                <th class="text-center sorting_disabled" rowspan="1" colspan="1" aria-label="操作" style="width: 80px">
                  操作
                </th>
              </tr>
              </thead>
              <tbody class="fw-semibold text-gray-600">
              <tr v-for="(item, index) in pptGoodsList" :key="index"
                  :class="{ old: index % 2 == 0, even: index % 2 != 0 }">
                <td>
                  <div class="d-flex align-items-center">
                    <a href="javascript:void(0);" class="symbol symbol-50px">
                      <img class="symbol-label lozad" v-if="item.picUrl.indexOf('http') == 0" :src="`${item.picUrl}`"/>
                      <img class="symbol-label lozad" v-else :src="`https://www.3jzc.cn${item.picUrl}`"/>
                    </a>
                    <div class="ms-5">
                      <a href="javascript:void(0);" class="text-gray-800 text-hover-primary fs-5"
                         data-kt-ecommerce-product-filter="product_name">{{ item.title }}</a>
                    </div>
                  </div>
                </td>

                <!-- 操作 -->
                <td class="text-end">
                  <el-link type="danger" @click="delGroupGoods(item)">删除</el-link>
                </td>
              </tr>
              </tbody>
            </table>

          </div>
        </el-col>
      </el-row>

    </ModalDialog>

  </div>
</template>

<script>

import OwnGoods from "@/views/Article/ArticleManage/OwnGoodsList.vue";
import AddOrUpdateTravel from "./ArticleManage/AddOrUpdate/AddOrUpdateArticle.vue";
import {mixins} from "./mixins";

import {selectionGoodsApi, updateBatchFreightApi, updateBatchSevenNrrApi,} from "@/api/goodsManageApi";
import {getFreightListApi} from "@/api/freightApi";
import {
  getDestinationByStaffIdApi,
  getGoodsGroupByStaffIdApi,
  getWxShopByStaffIdApi,
  getWxTopicByStaffIdApi
} from "@/api/groupGoodsApi";


export default {
  mixins: [mixins],
  name: "travelManage",
  components: {
    OwnGoods,
    AddOrUpdateTravel
  },
  // 组件的props定义,用于子组件接收父组件传值
  props: {},
  // 组件的data属性
  data() {
    return {
      state: "",
      groupProps: [],
      shopProps: [],
      topicProps: [],
      unitOptions: [
        {
          value: "1",
          label: "%",
        },
        {
          value: "2",
          label: "元",
        },
      ],
      adjustOptions: [
        //{
        //  value: "1",
        //  label: "上调",
        //},
        {
          value: "2",
          label: "下降",
        },
      ],
      options: [
        //{
        //  value: "1",
        //  label: "销售价",
        //},
        {
          value: "2",
          label: "市场价",
        },
        {
          value: "3",
          label: "分销价",
        },
      ],
      salePriceReference: "1",
      checkboxInput: true,
      idArr: [],
      categoryOne: [],
      categoryTwo: [],
      loading: false,
      role: localStorage.getItem('role'),
      pushGoodsObj: {
        topicIds: [],
        shopIds: [],
        goodsGroupIds: [],
        selectionObjects: [],
        goodsIds: [],
        isJd: 1,
        salePriceChange: "2",
        supplPriceChange: "2",
        salePriceDto: {
          salePriceReference: "2",
          salePriceAdjust: "2",
          salePriceNum: "",
          salePriceUnit: "1",
        },
        supplPriceDto: {
          supplPriceReference: "2",
          supplPriceAdjust: "2",
          supplPriceNum: "",
          supplPriceUnit: "1",
        },
      },
      value1: 1,
      fVisible: false,
      sevenNrrVisible: false,
      goodsUrl: "",
      id: "",
      index: 1,
      rows: [],
      form: {
        freightId: "",
      },
      freightList: [],
      orderStatus: [
        {
          title: "资讯管理",
          count: 0,
          icon: "ki-outline ki-bookmark-2 fs-5 me-2",
        }
      ],
    };
  },
  // 组件的方法
  methods: {
    //子传父数据
    setArrId(idarr) {
      this.idArr = idarr;
    },
    async pushGood(id, state) {
      this.state = 1;
      this.id = id;
      this.$refs.pushGoodsAll.open();
      this.shopProps = [];
      this.topicProps = [];
      this.groupProps = [];
      let {data: res1} = await getWxTopicByStaffIdApi();
      res1.forEach((item, index) => {
        this.topicProps.push({
          id: item.id,
          label: item.title,
        });
      });
      let {data: res2} = await getWxShopByStaffIdApi();
      res2.forEach((item, index) => {
        this.shopProps.push({
          id: item.id,
          label: item.name,
        });
      });
      let {data: res3} = await getGoodsGroupByStaffIdApi();
      res3.forEach((item, index) => {
        this.groupProps.push({
          id: item.id,
          label: item.name,
        });
      });
    },
    async submitPush(id) {
      this.pushGoodsObj.topicIds = [];
      this.pushGoodsObj.shopIds = [];
     // this.pushGoodsObj.goodsGroupIds = [];
      this.pushGoodsObj.goodsIds = [];
      if (this.pushGoodsObj.selectionObjects.includes("topic")) {
        this.pushGoodsObj.topicIds = this.$refs.topicTree.getCheckedKeys();
        if (this.pushGoodsObj.topicIds.length == 0) {
          let index = this.pushGoodsObj.selectionObjects.indexOf("topic");
          this.pushGoodsObj.selectionObjects.splice(index, 1);
        }
      }
      if (this.pushGoodsObj.selectionObjects.includes("shop")) {
        this.pushGoodsObj.shopIds = this.$refs.shopTree.getCheckedKeys();
        if (this.pushGoodsObj.shopIds.length == 0) {
          let index = this.pushGoodsObj.selectionObjects.indexOf("shop");
          this.pushGoodsObj.selectionObjects.splice(index, 1);
        }
      }
      /*if (this.pushGoodsObj.selectionObjects.includes("group")) {
        this.pushGoodsObj.goodsGroupIds = this.$refs.groupTree.getCheckedKeys();
        if (this.pushGoodsObj.goodsGroupIds.length == 0) {
          let index = this.pushGoodsObj.selectionObjects.indexOf("group");
          this.pushGoodsObj.selectionObjects.splice(index, 1);
        }
      }*/
      /*if (this.pushGoodsObj.supplPriceChange == "2") {
        this.pushGoodsObj.supplPriceDto = {
          supplPriceReference: "",
          supplPriceAdjust: "",
          supplPriceNum: "",
          supplPriceUnit: "",
        };
      }
      if (this.pushGoodsObj.salePriceChange == "2") {
        this.pushGoodsObj.salePriceDto = {
          salePriceReference: "",
          salePriceAdjust: "",
          salePriceNum: "",
          salePriceUnit: "",
        };
      }*/
      if (this.id == "") {
        this.pushGoodsObj.goodsIds = this.idArr;
      } else {
        this.pushGoodsObj.goodsIds = [this.id];
      }
      this.pushGoodsObj.isJd = 2;

      //let arr = ["group", "shop", "topic"];
      let arr = ["shop", "topic"];
      let arr1 = [];
      arr.forEach((item) => {
        if (this.pushGoodsObj.selectionObjects.includes(item)) {
          arr1.push(item);
        }
      });

     // let goodNum = this.pushGoodsObj.goodsIds.length;
      let {data} = await selectionGoodsApi(this.pushGoodsObj);
      // 不成功的数据
      /*let total = 0;
      for (let key in data) {
        if (data.hasOwnProperty(key)) {
          total += data[key];
        }
      }
      if (total === 0) {
        this.$message({
          message: "全部商品推送成功",
          type: "success",
        });
      } else if (total >= goodNum) {
        this.$message({
          message: "商品全部推送失败，请检查价格比例或者商城已存在商品!",
          type: "error",
        });
      } else if (total < goodNum) {
        this.$message.warning("商品部分推送失败，请调整价格比例或部分商品已被推送!")
      }*/
      this.$message({
        message: "推送成功",
        type: "success",
      });

      this.idArr = [];
      this.$refs.pushGoodsAll.close();
      this.$refs.pushGrounp.close();
    },
    async updatePrice(id, isJd) {
      this.$refs.goodInfoComponent.openGoodsInfo(id, isJd);
      this.$message({
        message: "更新成功",
        type: "success",
      });
    },
    async nextPush() {
      if (this.pushGoodsObj.selectionObjects.length == 0) {
        this.$message({
          message: "请选择推送目标",
          type: "warning",
        });
        return;
      }
      this.$refs.pushGrounp.open();
    },
    /* 商品推送 1 */
    async pushAll() {
      this.id = "";
      this.state = ""
      if (this.idArr.length == 0) {
        return;
      }
      this.$refs.pushGoodsAll.open();
      this.shopProps = [];
      this.topicProps = [];
     // this.groupProps = [];
      let {data: res1} = await getWxTopicByStaffIdApi();
      res1.forEach((item, index) => {
        this.topicProps.push({
          id: item.id,
          label: item.title,
        });
      });
     // let {data: res2} = await getWxShopByStaffIdApi();
      let {data: res2} = await getDestinationByStaffIdApi();
      res2.forEach((item, index) => {
        this.shopProps.push({
          id: item.id,
          label: item.title,
        });
      });
      /*let {data: res3} = await getGoodsGroupByStaffIdApi();
      res3.forEach((item, index) => {
        this.groupProps.push({
          id: item.id,
          label: item.name,
        });
      });*/
    },
    addIdArr(id) {
      if (this.idArr.includes(id)) {
        let index = this.idArr.indexOf(id);
        if (index !== -1) {
          this.idArr.splice(index, 1);
        }
      } else {
        this.idArr.push(id);
      }
      let a = true;
      this.rows.forEach((e) => {
        if (!this.idArr.includes(e.id)) {
          a = false;
        }
      });
      this.checkboxInput = a;
    },
    async batchOperations(command) {
      this.idArr = this.$refs.OwnGoods.idArr;
      if (this.idArr.length == 0) {
        this.sevenNrrVisible = false;
        this.$swal.fire({
          icon: "error",
          title: "请选中一个及以上的线路!",
          toast: true,
          position: "center",
          showConfirmButton: false,
          timer: 2000,
        });
        return;
      }
      if (command == "sevenNrr") {
        this.sevenNrrVisible = true;
      }
      if (command == "freight") {
        this.fVisible = true;
        let {data} = await getFreightListApi({
          size: 200,
          current: 1,
        });
        this.freightList = data.rows;
        const ownGoodsComponent = this.$refs.OwnGoods; // 通过ref获取组件实例
        if (ownGoodsComponent && ownGoodsComponent.getSjGoodsList) {
          // 调用子组件方法
          await ownGoodsComponent.getSjGoodsList();
        }
      }
      if (command == "push") {
        this.pushAll();
      }
    },
    async batchFreight() {
      let {data} = await updateBatchFreightApi(
          JSON.stringify({
            ids: this.idArr,
            freightId: this.form.freightId,
          })
      );
      this.$swal.fire({
        icon: "success",
        title: "操作成功!",
        toast: true,
        position: "center",
        showConfirmButton: false,
        timer: 2000,
      });
      const ownGoodsComponent = this.$refs.OwnGoods; // 通过ref获取组件实例
      if (ownGoodsComponent && ownGoodsComponent.getSjGoodsList) {
        // 调用子组件方法
        await ownGoodsComponent.getSjGoodsList();
      }
      this.fVisible = false;
      this.$refs.OwnGoods.idArr = [];
      this.$refs.OwnGoods.checkboxInput = false;
      this.idArr = [];
    },
    async batchSevenNrr() {
      let {data} = await updateBatchSevenNrrApi(
          JSON.stringify({
            ids: this.idArr,
            sevenNRR: this.value1,
          })
      );
      this.$swal.fire({
        icon: "success",
        title: "操作成功!",
        toast: true,
        position: "center",
        showConfirmButton: false,
        timer: 2000,
      });
      const ownGoodsComponent = this.$refs.OwnGoods; // 通过ref获取组件实例
      if (ownGoodsComponent && ownGoodsComponent.getSjGoodsList) {
        // 调用子组件方法
        await ownGoodsComponent.getSjGoodsList();
      }
      this.sevenNrrVisible = false;
      this.$refs.OwnGoods.idArr = [];
      this.$refs.OwnGoods.checkboxInput = false;
      this.idArr = [];
    },
    handleCommand(a) {
      this.$router.push(a);
    },


    /*exp() {
      if (this.index) {
      // 导出数据
      this.$refs.OwnGoods.exp();
      } else {
      }
    },*/

    // 将商品id传给子组件
    gotoGoods(id) {
      if (id) {
        this.id = id;
      } else {
        this.id = "";
      }
    },
    // 选择推送目标改变时触发
    changeSelectionObjects() {
      if (this.pushGoodsObj.selectionObjects == 'group') {
        this.pushGoodsObj.salePriceChange = '2'
        this.pushGoodsObj.salePriceDto.salePriceNum = null
      }
    },
    // 按照价格改变时 调整方式需要改变
    changeSalePrice() {
      if (this.pushGoodsObj.salePriceDto.salePriceReference == 2) {
        this.pushGoodsObj.salePriceDto.salePriceAdjust = "2";
        this.adjustOptions = [
          {
            value: "2",
            label: "下降",
          },
        ]
      } else {
        this.adjustOptions = [
          {
            value: "1",
            label: "上调",
          },
          {
            value: "2",
            label: "下降",
          },
        ]
      }
    },
    // 输入价格时校验数据
    inputPriceNum() {
      let value = parseFloat(this.pushGoodsObj.salePriceDto.salePriceNum);
      if (this.pushGoodsObj.salePriceDto.salePriceUnit == "1" && (isNaN(value) || value < 0 || value > 99.99)) {
        this.$message.error("请输入正确的比例! 0~99.99")
        this.pushGoodsObj.salePriceDto.salePriceNum = null;
      } else if (this.pushGoodsObj.salePriceDto.salePriceUnit == "2" && (isNaN(value) || value < 0)) {
        this.$message.error("请输入正数!")
        this.pushGoodsObj.salePriceDto.salePriceNum = null;
      }
    },
    // 改变加价方式(单位) 时 将加价 价格 置为空
    changePriceUnit() {
      this.pushGoodsObj.salePriceDto.salePriceNum = null;
    },
    // 将多选改成单选
    setTree(data, typeName) {
      this.$refs[typeName].setCheckedKeys([]);
      if (data) {
        this.$refs[typeName].setCheckedNodes([data]);
      }
    },
    groupTreeNodeClick(data) {
      this.setTree(data, "groupTree")
    },
    shopTreeNodeClick(data) {
      this.setTree(data, "shopTree")
    },
    topicTreeNodeClick(data) {
      this.setTree(data, "topicTree")
    },
    canUseExportGoods2Other() {
      return JSON.parse(this.role).some(item => item === 'firstGradeSupplier' || item === 'vipMember');
    }

  },
  // 在created钩子中执行的操作
  created() {
  },
};
</script>


<!-- 组件的样式 -->
<style>
.imageListItem {
  box-shadow: rgba(54, 54, 54, 0.4) 0px 0px 10px;
  background: #fff;
  margin: 20px;
  padding: 15px;
  padding-right: 0;
  box-sizing: border-box;
  border-radius: 10px;
}

.imageListItem img {
  width: 100% !important;
  aspect-ratio: 601 / 335;
  border-radius: 6px;
  margin-top: 10px;
  margin-left: -20px;
}

.el-drawer__header {
  margin-bottom: 0px !important;
  padding-bottom: 12px !important;
}

.content_box {
  background: #ffffff;
  padding: 20px;
}

.imgItem {
  width: 10%;
  aspect-ratio: 1/1;
  padding: 1px;
  //margin-top: 24px; position: relative; margin-right: 10px;
}


.removeImage {
  position: absolute;
  right: 1px;
  top: 10px;
  width: 25px;
  height: 25px;
  background: #ffffffc9;
  border-radius: 50%;
  border: 0;
  text-align: center;
  line-height: 25px;
}
</style>
